<app-navigation
    [additionalContainerClasses]="[]"
    [automaticFooterPadding]="false">
    <app-trips-itinerary-detail></app-trips-itinerary-detail>
</app-navigation>
